import { Pipe, PipeTransform } from '@angular/core';
import { RpaDto } from '@flyfreely-portal-ui/flyfreely';

@Pipe({ name: 'rpaStatusClass' })
export class RpaStatusClassPipe implements PipeTransform {
    transform(status: RpaDto.Status) {
        switch (status) {
            case RpaDto.Status.SERVICEABLE:
                return 'rpa-status-serviceable';
            case RpaDto.Status.UNSERVICEABLE:
                return 'rpa-status-unserviceable';
            case RpaDto.Status.RETIRED:
                return 'rpa-status-retired';
            case RpaDto.Status.UNDER_MAINTENANCE:
                return 'rpa-status-under-maintenance';
            default:
                return `rpa-status-${status.toLowerCase()}`;
        }
    }
}
